import { NotificationService } from '@progress/kendo-angular-notification';
import { get, isEmpty } from 'lodash';
import { dialogTimer } from '../../../app/shared/constants/dialog-specs';
import { NOTIFICATION_MESSAGES } from '../constants/notification-messages';

export function showAvailabilityNotification(
  response: { availability?: string }[],
  notificationService: NotificationService
): void {

  const availability = get(response, '[0].availability', '');

  const message = isEmpty(availability)
  ? NOTIFICATION_MESSAGES.selectedSlotUnavailable
  : NOTIFICATION_MESSAGES.selectedSlotUnavailableWithReason(
      (availability as string).replace(/^Not Available\s*-\s*/i, '')
    );

  notificationService.show({
    content: message,
    hideAfter: dialogTimer,
    position: { horizontal: 'center', vertical: 'top' },
    animation: { type: 'slide', duration: 60 },
    type: { style: 'warning', icon: true },
  });
}